import { takeLatest, call, put } from "redux-saga/effects";
import { UNLOCK_LINKEDIN_BANNER_REQUEST } from "../actionTypes";

import {
  unlockLinkedInBannerSuccess,
  unlockLinkedInBannerFailure,
} from "./actions";
import AxiosInstance from "../../services/AxiosInstance";
// Worker saga
function* unlockLinkedInBanner(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/unlock_premium_banner", action.payload)
    );

    if (response.data.status == true) {
      yield put(unlockLinkedInBannerSuccess(response.data));
    } else {
      yield put(unlockLinkedInBannerFailure(response.data));
    }
  } catch (error) {
    yield put(
      unlockLinkedInBannerFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* unlockLinkedinBannerSaga() {
  yield takeLatest(UNLOCK_LINKEDIN_BANNER_REQUEST, unlockLinkedInBanner);
}
export default unlockLinkedinBannerSaga;
